const userFormDefaults = {
    name: '',
    username: '',
    permissions: [],
    roles: [],
};
export default userFormDefaults;
//# sourceMappingURL=userFormDefaults.js.map